

















































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

@Component({
  components: {
    VuePerfectScrollbar
  }
})
export default class Sidebar extends Vue {
  @Prop() isSidebarCollapsed: boolean = false
  ongoingCount: number = 0

  logout () {
    this.$store.dispatch('logout').then(() => {
      this.$router.push('/sadmin/login')
    }, reason => { })
  }

  mounted () {
    this.ongoingConversationCount()
  }

  ongoingConversationCount () {
    this.$http.get('ongoing-conversation-count')
      .then((response: any) => {
        this.ongoingCount = response.data.ongoingCount
      })
  }
}
